import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal } from "react-bootstrap";
import useStateRef from 'react-usestateref';
import { Link,json,useNavigate } from "react-router-dom";
import Card from "../../../../../components/Card";
import swal from 'sweetalert';
//import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";
import Select from 'react-select';
import "../../../../App.css";


const TableData = () => {

 
 const [SaveButtonText, setSaveButtonText] = useState("Save");
 
 
  useEffect(() => {

    
    
	
	
   if(sessionStorage.getItem("NonTaggedScreen_Action")=="Add")
   {
	    setSaveButtonText("Save");
      
     
    setId("{Auto}");
    
	//Clear();
   
   }
   else if(sessionStorage.getItem("NonTaggedScreen_Action")=="Edit")
   {
	   setSaveButtonText("Update");
	   Display(sessionStorage.getItem("NonTaggedScreen_EditId"));
   }
   else if(sessionStorage.getItem("NonTaggedScreen_Action")=="Delete")
   {
	   setSaveButtonText("Delete");
	   Display(sessionStorage.getItem("NonTaggedScreen_EditId"));
   }
	
   ControlSettings();
   innitialSetValue();
   

  }, []);
  
  function innitialSetValue() {


  getLookup();
  
  GetGrnDetails1();
  }

  
  const [dtProd, setdtProd]=useState([]);
  const [dtSubProd, setdtSubProd]=useState([]);
  const [dtGrnDetails, setdtGrnDetails]=useState([]);
  const [dtGrnDetailsOrg, setdtGrnDetailsOrg]=useState([]);
  
  
   const [TMshow1, setTMShow1] = useState(false);
   const TMhandleClose1 = () => setTMShow1(false);
  


   const [LotNo, setLotNo, LotNoRef] = useStateRef(0);
   
   const [LotDate, setLotDate, LotDateRef] = useStateRef((new Date()).toISOString().substring(0,10));
   
   const [ProdName1, setProdName1, ProdName1Ref] = useStateRef('');
   const [GrossWt1, setGrossWt1, GrossWt1Ref] = useStateRef(0);
   const [GrossWtC1, setGrossWtC1, GrossWtC1Ref] = useStateRef(0);
   const [GrossWtP1, setGrossWtP1, GrossWtP1Ref] = useStateRef(0);
   const [Pcs1, setPcs1, Pcs1Ref] = useStateRef(0);
   const [PcsC1, setPcsC1, PcsC1Ref] = useStateRef(0);
   const [PcsP1, setPcsP1, PcsP1Ref] = useStateRef(0);
 

   const [Id, setId, IdRef] = useStateRef(0);
   const [ProdCode, setProdCode, ProdCodeRef] = useStateRef(0);
   const [SubCode, setSubCode, SubCodeRef] = useStateRef(0);
   
   const [Pcs, setPcs, PcsRef] = useStateRef(0);
   const [GrossWt, setGrossWt, GrossWtRef] = useStateRef(0);
   const [NetWt, setNetWt, NetWtRef] = useStateRef(0);
   const [Rate, setRate, RateRef] = useStateRef(0);
   const [PurRate, setPurRate, PurRateRef] = useStateRef(0);
   const [LessWt, setLessWt, LessWtRef] = useStateRef(0);
   
   const [SearchTxt, setSearchTxt, SearchTxtRef] = useStateRef('');

 



function SearchFun(text)
{
  setdtGrnDetails(dtGrnDetailsOrg.filter(function (x) {
    return x.LotNo.toLowerCase().indexOf(text.toLowerCase()) > -1;
}))
}  

 
  async function Clear()
   {
    
    setProdCode(0);
    setSubCode(0);
    setPcs(0);
    setGrossWt(0);
		setLessWt(0);
    setNetWt(0);
    setRate(0);
    setPurRate(0);
    setId("{Auto}");
    
		
   }

function val(value)
{
	value=parseFloat(value);
	if(isNaN(value)==true)
		value=0;
	else
		value=value;
	
	return value;
}



async function Calc()
{
  
  setNetWt(val(GrossWtRef.current)-val(LessWtRef.current));

  if(val(NetWtRef.current)>val(GrossWtP1Ref.current))
  {
    let DiffWt=val(NetWtRef.current)-val(GrossWtP1Ref.current);
    swal({
      title: "",
      text: "The Weight Difference : " + DiffWt,
      icon: "info",
      button: "Ok"
    
    });
    
    setGrossWt(0);
    setLessWt(0);
    setNetWt(0);
    
    return;
  }
  else
  {
    setNetWt(val(val(GrossWtRef.current)-val(LessWtRef.current)).toFixed(2));

  }








}


async function ControlSettings()
{

  document.getElementById("txtLotNo").disabled ='true';
  
  
  if((sessionStorage.getItem("NonTaggedScreen_Action")=="Edit") || (sessionStorage.getItem("NonTaggedScreen_Action")=="Delete"))
   {
  
   
   }
}



async function GetGrnDetails1()
{
  try
  {
   
    let postData = {
      "BranchCode":sessionStorage.getItem("BranchCode")
  }

  const results = await apiService.postCall("nontaggedscreen/GetGrnDetails1",postData);

 if (results != "-1") {
   setdtGrnDetails(results.data[0]);
   setdtGrnDetailsOrg(results.data[0]);
 }

  
  }
  catch (error) {
    console.log(error);
  }
}


async function Display(EditId){
	  try
    {
     
      let postData = {
        EditId: EditId
    }

    const results = await apiService.postCall("nontaggedscreen/Display",postData);


   if (results != "-1") {
     
	 let HeadData=results.data.Head;


   getLookup();

   setLotNo(HeadData[0][0].LotNo);
   setLotDate(HeadData[0][0].TransDate.substring(0,10));
   setId(HeadData[0][0].Id);
   
   setProdCode(HeadData[0][0].ProdCode);
   setSubCode(HeadData[0][0].subcode);
   setPcs(HeadData[0][0].Pcs);
   setGrossWt(HeadData[0][0].Grosswt.toFixed(2));
   setRate(HeadData[0][0].Rate);
   setLessWt(HeadData[0][0].LessWt.toFixed(2));
   setNetWt(HeadData[0][0].NetWt.toFixed(2));
   setPurRate(HeadData[0][0].PurRate);
   
   await setCheck(LotNoRef.current);

   await Calc();

   }

    
    }
    catch (error) {
      console.log(error);
    }

  }

  async function Err(msg)
  {
 
        swal({

          title: "",
          text: msg,
          icon: "info",
          button: "Ok"
          
        }).then(function () {
          
        });
  }


async function Save(){
	  try
		{
	
		// validation start
		
  
    if(LotNoRef.current=="0")
    {
      await Err("Please Select Lot No");
      return;
    }

    if(ProdCodeRef.current=="0")
    {
      await Err("Please Select Product");
      return;
    }

    if(SubCodeRef.current=="0")
    {
      await Err("Please Select Sub Product");
      return;
    }

    if(val(PcsRef.current)=="0")
    {
      await Err("Enter Pcs");
      return;
    }

    if(val(GrossWtRef.current)=="0")
    {
      await Err("Enter GrossWt");
      return;
    }

    
      

      // validation end


      

		 
		let postData = {
			"Action" : sessionStorage.getItem("NonTaggedScreen_Action"),
			"EditId" : sessionStorage.getItem("NonTaggedScreen_EditId"),
      "eBranchCode" : sessionStorage.getItem("BranchCode"),
			"FinMinDate": sessionStorage.getItem("FinMinDate"),
			"FinMaxDate": sessionStorage.getItem("FinMaxDate"),
			"EntryUser":sessionStorage.getItem("EntryUser"),
		  "LotNo":LotNoRef.current,
      "LotDate":LotDateRef.current,
      "ProdCode":ProdCodeRef.current,
      "SubCode":SubCodeRef.current,
      "Pcs":PcsRef.current,
      "GrossWt":GrossWtRef.current,
      "Rate":RateRef.current,
      "LessWt":LessWtRef.current,
      "NetWt": NetWtRef.current,
      "PurRate": PurRateRef.current,
     
    }

    
    
 
   const results = await apiService.postCall("nontaggedscreen/Save",postData);



   if (results != "-1") {

if(results.errorCode=="8888")
{


  swal({

    title: "Alert",
    text: results.data,
    icon: "info",
    button: "Ok"
    
  }).then(function () {
    return;
  });

  return;

}  




  if(sessionStorage.getItem("NonTaggedScreen_Action")=="Add")
   {
    swal({

      title: "Success",
      text: "Successfully Add Your Details!",
      icon: "success",
      button: "Ok"

    }).then(async function () {
      await setCheck(LotNoRef.current);

     Clear();

     if(val(PcsP1Ref.current)==0)
      {BackToList();}
    });
	
  }

  else if(sessionStorage.getItem("NonTaggedScreen_Action")=="Edit")
   {
    swal({

      title: "Success",
      text: "Successfully Update Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }
	 
  else if(sessionStorage.getItem("NonTaggedScreen_Action")=="Delete")
  {
   swal({

     title: "Success",
     text: "Successfully Delete Your Details!",
     icon: "success",
     button: "Ok"

   }).then(function () {
     BackToList();
   });
 
 }
	 
      }
    }
    catch (error) {
      console.log(error);
    }

  }

  async function setCheck(id)
  {

    try
  {
   
   
  
    let postData = {
      "IssueNo": id,
      "Id":IdRef.current
  }

  const results = await apiService.postCall("nontaggedscreen/GetGrnDetails",postData);

 if (results != "-1") {
  
  let data=results.data[0];
  


  setLotNo(data[0][0].GrnNo);
  setLotNo(data[0][0].LotNo);

  setProdName1(data[0][0].ProdName);
  setGrossWt1(data[0][0].Grosswt.toFixed(2));
  setGrossWtC1(data[0][0].TagedWt.toFixed(2));
  setGrossWtP1(data[0][0].BWt.toFixed(2));
  setPcs1(data[0][0].Pcs);
  setPcsC1(data[0][0].TagedPcs);
  setPcsP1(data[0][0].BPcs);
  
  
 
 }

 setTMShow1(false);

  
  }
  catch (error) {
    console.log(error);
  }

   


}





  async function getsubProd(){
    try {
     
     let postData = {
      "ProdCode" : ProdCodeRef.current
     };
     
  
    const results = await apiService.postCall("nontaggedscreen/getsubProd",postData);
 
    if (results != "-1") {
      setdtSubProd(results.data[0][0]);
     }
} catch (error) {
       console.log(error);
     }
 }

  async function getLookup(){
	 try {		
				 
		let postData = {
      "ProdCode" : ProdCodeRef.current
    };
		
    const results = await apiService.postCall("nontaggedscreen/Lookup",postData);

	 if (results != "-1") {

    setdtProd(results.data[0][0]);
    setdtSubProd(results.data[1][0]);
    
      }

    } catch (error) {
      console.log(error);
    }
}

 
  const navigate = useNavigate();
  const BackToList = () => {
    navigate('../dashboard/table/plussing/nontaggedscreen/list');
  };

  return (
    <>
    

      <Row className="">
        <Card>
          <Card.Header className="d-flex justify-content-between">
            <div className="header-title">
              <h4 className="card-title">Non-Tagged Entry Screen</h4>
            </div>
          </Card.Header>
          <Card.Body>
            <div className='container'>
              <div className='container-fluid'>
                <div className='row'>
                  <div className='col-lg-12' id="div100">
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='container-fluid py-4 '>
                        <div className='row py-4'>

                        <div className='col-md-2'>
                            <Form.Label><a onClick = {(e) => {
                              if(sessionStorage.getItem("NonTaggedScreen_Action")=="Add")
                             { setTMShow1(true)}

                              }} href="#">Lot No</a></Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtLotNo" placeholder="" value={LotNo}  />
                          </div>
                         
                          <div className='col-md-3'>
                            <Form.Label>Date</Form.Label>
                            <Form.Control type="date" Readonly="Readonly" disabled="disabled" id="txtLotDate" placeholder="" value={LotDate} onChange={(e)=>setLotDate(e.target.value)} />
                          </div>

                          <div className='col-md-7'>
                            <Form.Label>Product Name</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtProdName1" placeholder="" value={ProdName1} onChange={(e)=>setProdName1(e.target.value)} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Gross Wt</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtGrossWt1" placeholder="" value={GrossWt1} onChange={(e)=>setGrossWt1(e.target.value)} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Completed</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtGrossWtC1" placeholder="" value={GrossWtC1} onChange={(e)=>setGrossWtC1(e.target.value)} />
                          </div>


                          <div className='col-md-4'>
                            <Form.Label>Pending</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtGrossWtP1" placeholder="" value={GrossWtP1} onChange={(e)=>setGrossWtP1(e.target.value)} />
                          </div>



                          <div className='col-md-4'>
                            <Form.Label>Pcs</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtPcs1" placeholder="" value={Pcs1} onChange={(e)=>setPcs1(e.target.value)} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Completed</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtPcsC1" placeholder="" value={PcsC1} onChange={(e)=>setPcsC1(e.target.value)} />
                          </div>


                          <div className='col-md-4'>
                            <Form.Label>Pending</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtPcsP1" placeholder="" value={PcsP1} onChange={(e)=>setPcsP1(e.target.value)} />
                          </div>

    
   </div>
	  </div>
</div>

</div>


                  </div>
                 


                  <div className='row'>
                  <div className='col-lg-6'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='container-fluid py-4 '>
                        <div className='row py-4'>

                          <div className='col-md-12'>
                            <Form.Label>Product</Form.Label>

                            <Select className="form-select-search" isSearchable={true} onBlur={Calc}
                                          value={dtProd.filter(function(option) {
                                             return option.value === ProdCode;
                                           })}
                                          options={dtProd}
                                          id="txtProd"  
                                          onChange=
                                          {
                                             (e) => {
                                              setProdCode(e.value)
                                              getsubProd()   
                                             }
                                             } >

                            </Select>


                            
                          </div>


                          <div className='col-md-12'>
                            <Form.Label>Sub Product</Form.Label>
                            <Select className="form-select-search" isSearchable={true} onBlur={Calc}
                                          value={dtSubProd.filter(function(option) {
                                             return option.value === SubCode;
                                           })}
                                          options={dtSubProd}
                                          id="txtSubProd"  
                                          onChange=
                                          {
                                             (e) => {
                                              setSubCode(e.value)
                                             }
                                             } >

                            </Select>

                          </div>


                        


                        
                        

   </div>
	  </div>
</div>

</div>


  <div className='col-lg-6'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='container-fluid py-4 '>
                        <div className='row py-4'>
                        <div className='col-md-4'>
                            <Form.Label>Id</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtTagId" placeholder="" value={Id} onChange={(e)=>setId(e.target.value)} />
                          </div>
                       
                         

                          

                          <div className='col-md-4'>
                            <Form.Label>Pcs</Form.Label>
                            <Form.Control type="text"  id="txtPcs" placeholder="" value={Pcs} onChange={(e)=>setPcs(e.target.value)} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Gross Wt</Form.Label>
                            <Form.Control type="text" id="txtGrossWt" placeholder="" value={GrossWt} 
                            onChange={(e)=>{setGrossWt(e.target.value)
                            }
                          } onBlur={Calc} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Less Wt</Form.Label>
                            <Form.Control type="text"   id="txtLessWt" placeholder="" value={LessWt} onChange={(e)=>{
                              setLessWt(e.target.value)
                              }} onBlur={Calc} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Net Wt</Form.Label>
                            <Form.Control type="text"  Readonly="Readonly" disabled="disabled" id="txtNetWt" placeholder="" value={NetWt} onChange={(e)=>setNetWt(e.target.value)} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Rate</Form.Label>
                            <Form.Control type="text"  id="txtRate" placeholder="" value={Rate} onChange={(e)=> 
                            {
                              setRate(e.target.value)
                             
                            }} onBlur={Calc} />
                          </div>
                       

                          <div className='col-md-4'>
                            <Form.Label>Pur.Rate</Form.Label>
                            <Form.Control type="text"  id="txtPurRate" placeholder="" value={PurRate} onChange={(e)=> 
                            {
                              setPurRate(e.target.value)
                             
                            }} onBlur={Calc} />
                          </div>
                       


   </div>
	  </div>
</div>

</div>


</div>
                  
              </div>
             

        
			    
				
				<Modal show={TMshow1} onHide={TMhandleClose1} className=".modal-lg"  id ="otherlotentrytableModal" >
                  <Modal.Header closeButton>
                    <Form.Control type="text" placeholder='Search' value={SearchTxt} onChange={(e)=> { 
                      setSearchTxt(e.target.value)
                      SearchFun(e.target.value)
                      }}/>
                  </Modal.Header>

                  <Modal.Body>
                    
                                 
              <div className="table-responsive mt-4" id="otherlotentrytable1" >
			 
				
       <Table striped id="table-basic" className="table-striped mb-0" role="grid">
         <thead>
           <tr>
            <th>Lot No</th>
             <th>Prod Name</th>
             <th>Item Name</th>   
             <th>GRN No</th>              
             <th>Pcs</th>              
             <th>Weight</th>              
             
           </tr>
         </thead>
         <tbody>
         {dtGrnDetails.map((item) => (
           <tr>
            
   <td>  
    
     <Form.Check className="me-2">
                               
                               <Form.Check.Input type="radio" name="g1" onChange={(e) => setCheck(item.LotNo)} checked={item.checked} className="lstItems" id={item.LotNo} />
                               
                               <Form.Check.Label>{item.LotNo}</Form.Check.Label>
                             </Form.Check>
                             </td>
         
             
             <td>{item.ProdName}</td>
             <td>{item.SubProduct}</td>
             <td>{item.GrnNo}</td>
             <td>{item.BPcs}</td>
             <td>{item.BWt.toFixed(2)}</td>
            


           </tr>
             )
             )
              }     
         </tbody> 
       </Table>
      
     </div>

					 </Modal.Body>
                 </Modal>
				
	
          
              <div className='pt-2' style={{ direction: 'rtl' }} >
                <Form.Group className="form-group">
                  <Button type="button" variant='btn btn-primary' >
                    <i className="btn-inner">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
                      </svg>
                    </i>
                    <span>Print</span>
                  </Button>{' '}
                  <Button type="button" variant="btn btn-danger" onClick={BackToList}>cancel</Button> {' '}
                  <Button type="button" variant="btn btn-primary" onClick={Save}>{SaveButtonText}</Button>
                </Form.Group>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Row >
    </>
  );
};

export default TableData;
